"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_USER_ACCOUNTS = exports.REQUEST_MFA_RESET = exports.RESET_MFA_USER_OPTIONS = exports.VERIFY_MFA_CODE = exports.SEND_MFA_CODE = exports.USER_LOGIN = exports.ADMIN_LOGIN = void 0;
const client_1 = require("@apollo/client");
exports.ADMIN_LOGIN = (0, client_1.gql) `
  mutation AdminLogin($email: String!, $password: String!) {
    login: adminLogin(email: $email, password: $password) {
      ok
      error {
        message
        code
      }
      qrCode
      totpEnabled
    }
  }
`;
exports.USER_LOGIN = (0, client_1.gql) `
  mutation UserLogin($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
    }
  }
`;
exports.SEND_MFA_CODE = (0, client_1.gql) `
  mutation SendMFACode($data: SendMFACodeInput!) {
    sendMFACode(data: $data) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
      retryTimeout
    }
  }
`;
exports.VERIFY_MFA_CODE = (0, client_1.gql) `
  mutation VerifyMFACode($data: VerifyMFACodeInput!) {
    verifyMFACode(data: $data) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
    }
  }
`;
exports.RESET_MFA_USER_OPTIONS = (0, client_1.gql) `
  query GetResetMFAUserOptions($data: ResetMFAUserOptionsInput!) {
    resetMFAUserOptions(data: $data) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
      resetUserOptions {
        id
        firstName
        lastName
      }
    }
  }
`;
exports.REQUEST_MFA_RESET = (0, client_1.gql) `
  mutation RequestMFAReset($data: RequestMFAResetInput!) {
    requestMFAReset(data: $data) {
      ok
      error {
        message
        code
      }
      multifactorAuthEnabled
      phoneNumberVerified
      phoneNumber
    }
  }
`;
exports.GET_USER_ACCOUNTS = (0, client_1.gql) `
  query GetUserAccounts($email: String!) {
    getUserAccountsByEmail(email: $email) {
      id
      logoUrl
      name
      subdomain
    }
  }
`;
(0, client_1.gql) `
  mutation VerifyAdminTotp($data: TotpInput!) {
    verifyAdminTotp(data: $data) {
      ok
      error {
        message
        code
      }
    }
  }
`;
(0, client_1.gql) `
  mutation ResetTotpSetup($email: String!, $password: String!) {
    resetTotpSetup(email: $email, password: $password) {
      ok
      error {
        message
        code
      }
      qrCode
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,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